import type { FC } from 'react'
import React, { memo } from 'react'
import * as S from './Options.styled'
import type { Props } from './types'

const OptionsItemComponent: FC<Props> = ({ label, active = false, onClick }) => (
  <S.ItemContainer $active={active} onClick={onClick} data-testid="Options.Item">
    {label}
  </S.ItemContainer>
)

export const OptionsItem = memo(OptionsItemComponent)
